import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { setCredentials, logOut, licenseExpired, logOutAndResetApi } from 'features/auth/authSlice'
import { Navigate, useNavigate } from 'react-router-dom'


const baseQuery = fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}`,
    //credentials: 'include',
    prepareHeaders: (headers, { getState }) => {
        const token = getState().auth.token
        const companyGuid = getState().auth.company?.guid

        if (token) {
            headers.set("authorization", `Bearer ${token}`)
            headers.set("companyGUID", companyGuid)
        }
        return headers
    }
})

const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions)
    // if (result?.error?.originalStatus === 403) {
    //     console.log('sending refresh token')
    //     // send refresh token to get new access token 
    //     const refreshResult = await baseQuery('/refresh', api, extraOptions)
    //     console.log(refreshResult)
    //     if (refreshResult?.data) {
    //         const user = api.getState().auth.user
    //         // store the new token 
    //         api.dispatch(setCredentials({ ...refreshResult.data, user }))
    //         // retry the original query with new access token 
    //         result = await baseQuery(args, api, extraOptions)
    //     } else {
    //         api.dispatch(logOut())
    //     }
    // }

    if (result?.error?.status === 403) {
        console.warn('Insufficient permissions')
    }

    if (result?.error?.status === 401) {
        console.log('Unauthorized request')
        api.dispatch(logOutAndResetApi())
    }

    if (result?.error?.status === 402) {
        console.log('License is expired!')
        api.dispatch(licenseExpired())
    }

    return result
}

export const apiSlice = createApi({
    baseQuery: baseQueryWithReauth,
    endpoints: builder => ({})
})